export var source = "query PlanSizes($input: PlansInquiryInput) {\n  currentUser {\n    data {\n      plansInquiry(input: $input) {\n        ...SubscriptionPlan\n      }\n    }\n  }\n}";
import { source as fragment1 } from "./fragments/subscriptionPlan.graphql";
var combined = source  + "\n" + fragment1;
export default combined;